import { CSSProperties } from "react";

export type TextInputProps = {
  label: string;
  placeholder?: string;
  type?: "text" | "password";
  inputType?: TextInputType;
  onChangeText?: (text: string) => any;
  onFocusCallback?: () => void;
  onBlurCallback?: () => void;
  error?: string;
  value?: string;
  disabled?: boolean;
  readOnly?: boolean;
  leftIcon?: JSX.Element;
  onLeftIconClick?: () => void;
  inputLeftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  onRightIconClick?: () => void;
  onClick?: () => void;
  style?: CSSProperties;
};

export type TextInputRef = Pick<HTMLInputElement, "focus" | "blur">;

export enum TextInputType {
  Primary = "primary",
  Secondary = "secondary",
}
